import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Container, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { ProductBanner } from '../ProductBanner/ProductBanner/ProductBanner.js';
import { createImpressionEvent, createInteractionEvent } from '../utils/DataLayer/Events/ProductPromotionEvents.js';

const ProductPromotions = ({ products , supertitle , title , renderLocation , 'data-t': dataT , isLoading ,  })=>{
    const { currency  } = useIntl();
    const handleImpression = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createImpressionEvent(product, position, `promotion recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    const handleInteraction = React.useCallback((product, position)=>{
        DataLayer.pushEvent(createInteractionEvent(product, position, `promotion recommendation ${renderLocation}`, currency));
    }, [
        currency,
        renderLocation
    ]);
    if (products.length === 0 && !isLoading) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-promotions",
        "data-t": dataT || 'product-promotions'
    }, /*#__PURE__*/ React.createElement(Container, null, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "span",
        color: "text-secondary",
        className: "product-promotions__supertitle"
    }, supertitle), /*#__PURE__*/ React.createElement(Heading, {
        variant: "medium",
        component: "h2"
    }, title), /*#__PURE__*/ React.createElement(ProductBanner, {
        products: products,
        isLoading: isLoading,
        onProductImpression: handleImpression,
        onProductInteraction: handleInteraction
    })));
};
var ProductPromotions$1 = ProductPromotions;

export { ProductPromotions, ProductPromotions$1 as default };
//# sourceMappingURL=ProductPromotions.js.map
